import React from 'react'

import type { IconProps } from './types'

const ArrowDown: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
      <path
        d="M7.99982 9.38055L5.45248 6.83322C5.17648 6.55722 4.72848 6.55722 4.45248 6.83322C4.17648 7.10922 4.17648 7.55722 4.45248 7.83322L7.52848 10.9092C7.78915 11.1699 8.21115 11.1699 8.47115 10.9092L11.5471 7.83322C11.8231 7.55722 11.8231 7.10922 11.5471 6.83322C11.2711 6.55722 10.8232 6.55722 10.5472 6.83322L7.99982 9.38055Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowDown
